import { render, staticRenderFns } from "./lookSingleQuestion.vue?vue&type=template&id=614d061b&scoped=true&"
import script from "./lookSingleQuestion.vue?vue&type=script&lang=js&"
export * from "./lookSingleQuestion.vue?vue&type=script&lang=js&"
import style0 from "./lookSingleQuestion.vue?vue&type=style&index=0&id=614d061b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614d061b",
  null
  
)

export default component.exports